{"orderId":98,"foreignOrderId":"3128947123","canPrintShipmentLabel":false,"email":"erik.odenman@gmail.com","exchangePaymentUrl":null}